<template>
    <div>
        <vue-breadcrumbs :breadCrumbs='breadCrumbs'/>
        <div class="tab_navigation">
            <v-tabs v-model="tab">
                <v-tab>Маршруты</v-tab>
                <v-tab>Автобусы</v-tab>
            </v-tabs>
            <vue-add-button @onClick='onAdd'>
                {{tab==0 ? 'Добавить маршрут' : 'Добавить автобус'}} 
            </vue-add-button>
        </div>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <buses-route ref="busesRoute"/>
            </v-tab-item>
            <v-tab-item>
                <buses-bus ref="busesBus"/>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import VueBreadcrumbs from '@/components/ui/vueBreadcrumbs.vue'
import VueAddButton from '@/components/ui/vueAddButton.vue'
import busesBus from '@/components/administration/buses/busesBus.vue'
import BusesRoute from '@/components/administration/buses/busesRoute.vue'
export default {
    components: {
        VueBreadcrumbs,
        VueAddButton,
        busesBus,
        BusesRoute
    },
    data: () => ({
        tab: 0,
        breadCrumbs: [
            {
                text: 'Заведение блоков',
                to: '/administration/block'
            },
            {
                text: 'Автобусы',
                to: '/administration/block/tours',
            }
        ]
    }),
    watch: {
        tab(val) {
            if (val===0) {
                if (this.$refs.busesRoute) {
                    this.$refs.busesRoute.getList()
                }
            } else {
                if (this.$refs.busesBus) {
                    this.$refs.busesBus.getList()
                } 
            }
        }
    },
    methods: {
        onAdd() {
            if (this.tab==0) {
                this.$refs.busesRoute.onAdd()
            } else {
                this.$refs.busesBus.onAdd()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.tab_navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
}
</style>